import { componentProvider } from 'js-component-framework/es';

/**
 * Component for the Sticky Header.
 */
export default class StickyHeader {
  /**
   * Starts the component
   *
   * @param {HTMLElement} options.element The component element.
   */
  constructor({ element }) {
    this.element = element;

    // Initialize the component.
    this.init();
  }

  /**
   * Initialize the StickyHeader.
   */
  init = () => {
    if (!this.element) {
      return;
    }

    // Toggle 'is-pinned' class when element is "stuck".
    this.observer = new IntersectionObserver(([e]) => (
      e.target.classList.toggle('is-pinned', e.intersectionRatio < 1)
    ), { threshold: [1] });

    this.observer.observe(this.element);
  };
}

const stickyHeaderConfig = {
  name: 'sticky-header',
  component: StickyHeader,
};

componentProvider(stickyHeaderConfig);
